import React from 'react';
import { P3 } from 'components/typography';
import ActiveLink from 'components/active-link/active-link';
import lexemes from 'components/lexemes';

type BreadCrumbsItem = {
    label: string;
    url?: string;
};

type BreadCrumbsProps = {
    color?:
        | 'var(--color-primary-01)'
        | 'white'
        | 'var(--color-primary-02)'
        | 'var(--color-primary-03)'
        | 'var(--color-primary-04)'
        | 'var(--color-primary-05)'
        | 'var(--color-primary-06)'
        | undefined;
    hasRootItem?: boolean;
    list: BreadCrumbsItem[];
};

function Breadcrumbs({
    list,
    color = 'var(--color-primary-01)',
    hasRootItem = true,
}: BreadCrumbsProps) {
    return (
        <nav className="breadcrumbs" aria-label={lexemes.breadcrumbs.lxA11yLabel()}>
            <ol className="breadcrumbs__list" role="list">
                {hasRootItem ? (
                    <li className="breadcrumbs__list-item">
                        <ActiveLink activeClassName="active">
                            <a className="breadcrumbs__item" href={`/`}>
                                <P3 color={color}>{lexemes.breadcrumbs.lxHomeTitle()}</P3>
                            </a>
                        </ActiveLink>
                    </li>
                ) : null}
                {list.filter(Boolean).map(({ label, url }) =>
                    url ? (
                        <li className="breadcrumbs__list-item" key={label}>
                            <ActiveLink activeClassName="active">
                                <a className="breadcrumbs__item" href={url}>
                                    <P3 color={color}>{label}</P3>
                                </a>
                            </ActiveLink>
                        </li>
                    ) : (
                        <li className="breadcrumbs__list-item" aria-current="page" key={label}>
                            <span className="breadcrumbs__item">
                                <P3 color={color}>{label}</P3>
                            </span>
                        </li>
                    )
                )}
            </ol>
        </nav>
    );
}

export default Breadcrumbs;
